import React, { useState } from 'react'

import { Box, Hidden, NoSsr, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import Preview from 'artkive/components/Modals/Preview'
import { ART_BOOK } from 'artkive/constants/tracker/mainNavigation'
import useMobileBreakpoint from 'artkive/hooks/useMobileBreakpoint'
import theme from 'artkive/utils/theme'

import BookCoverPreview from 'images/ecom/books/BookCoverPreview.png'
import bubbles from 'images/ecom/get-started/bubbles.png'
import lines from 'images/ecom/get-started/lines_3.svg'

import { PreviewButton, Section, TextBox, Title } from './LookInsidePreview.style'

const useStyles = makeStyles(({ breakpoints }) => ({
  bookCover: {
    position: 'relative',
    zIndex: 1,
    margin: '24px 16px 16px',
    [breakpoints.up('md')]: {
      margin: '0 44px 0 -20px',
      '&::before': {
        position: 'absolute',
        content: "' '",
        background: `url(${bubbles}) no-repeat`,
        backgroundSize: '68px 131px',
        width: 68,
        height: 131,
        left: -32,
        bottom: 16,
        zIndex: -1,
      },
    },
  },
  // The PNG carries a transparent shadow margin, so 280px shows the frame's 250px cover. On desktop the -20px/44px
  // side margins lay it out as the frame's 240px book with a 64px gap before the text.
  image: {
    display: 'block',
    width: 280,
    [breakpoints.down('sm')]: {
      width: 365,
      maxWidth: '100%',
      margin: '0 auto',
    },
  },
  buttonGutter: {
    position: 'relative',
    '&::after': {
      position: 'absolute',
      content: "' '",
      background: `url(${lines}) no-repeat`,
      backgroundSize: '67px 62px',
      transform: 'translate(100%, 0)',
      width: 67,
      height: 62,
      right: -24,
      top: 0,
      [breakpoints.down('sm')]: {
        right: -4,
        width: 96,
        height: 88,
        backgroundSize: '96px 88px',
      },
    },
  },
}))

const LookInsidePreview = () => {
  const [isOpen, setIsOpen] = useState(false)
  const isMobile = useMobileBreakpoint()
  const classes = useStyles()

  return (
    <>
      <Section
        bgcolor={theme.colors.bg.sky}
        display='flex'
        flexDirection={isMobile ? 'column' : 'row'}
        justifyContent='center'
        alignItems='center'
      >
        <Hidden mdUp>
          <Typography variant='h2' align='center'>
            Kids Art Book Example
          </Typography>
        </Hidden>
        <Box className={classes.bookCover} flexGrow={isMobile ? 1 : 0}>
          <picture>
            <img
              decoding='async'
              loading='lazy'
              src={BookCoverPreview}
              alt='Kids Art Book cover'
              className={classes.image}
            />
          </picture>
        </Box>
        <TextBox maxWidth={224} position='relative'>
          <Hidden smDown>
            <Box mb={3}>
              <Title variant='h2'>Kids Art Book Example</Title>
            </Box>
          </Hidden>
          <PreviewButton
            variant='outlined'
            color='primary'
            size='large'
            onClick={() => setIsOpen(true)}
            trackerEvent={ART_BOOK.SAMPLE_BOOK_VIEW}
            className={classes.buttonGutter}
          >
            Look Inside
          </PreviewButton>
        </TextBox>
      </Section>

      {/* book preview modal */}
      <NoSsr>
        <Preview
          maxWidth={isMobile ? false : 'xl'}
          fullScreen={isMobile}
          fullWidth
          open={isOpen}
          onClose={() => setIsOpen(false)}
        />
      </NoSsr>
    </>
  )
}

export default LookInsidePreview
